//@flow

import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useBindedActions, useActions} from '../../../utils/globalStore';

import {actions} from '../duck';
import {
  getProductCategoryLayout,
  updateProductCategoryLayout,
} from '../promises/product-category-layout';

import type {RootState} from '../..';
import type {
  ProductCategoryAisleLayout,
  ProductCategoryMenuLayout,
  ProductCategoryLayout,
} from '../../../entities';

const productCategoryLayoutSelector = (state: RootState) =>
  state.homePage.productCategoryLayout;

export function useInitializeProductCategoryLayout() {
  const setProductCategoryLayout = useActions(actions.setProductCategoryLayout);

  const productCategoryLayout = useSelector(productCategoryLayoutSelector);

  useEffect(() => {
    getProductCategoryLayout().then(res => {
      setProductCategoryLayout(res);
    });
  }, [setProductCategoryLayout]);

  return productCategoryLayout;
}
export function useProductCategoryLayout(): ProductCategoryLayout {
  const productCategoryLayout = useSelector(productCategoryLayoutSelector);

  return productCategoryLayout;
}

const productCategoryLayoutActions = {
  setCategoryAisleLayout: actions.updateProductCategoryAisleLayout,
  setCategoryMenuLayout: actions.updateProductCategoryMenuLayout,
};

export function useProductCategoryLayoutActions() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const {setCategoryAisleLayout, setCategoryMenuLayout} = useBindedActions(
    productCategoryLayoutActions
  );

  const updateCategoryAisleLayout = async (
    request: ProductCategoryAisleLayout
  ) => {
    setLoading(true);
    try {
      const productCategoryLayout = await updateProductCategoryLayout({
        productCategoryAisle: request,
      });

      setCategoryAisleLayout(productCategoryLayout.productCategoryAisle);
    } catch (error) {
      console.log('exe');
      console.error({error});
      setError(true);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const updateCategoryMenuLayout = async (
    request: ProductCategoryMenuLayout
  ) => {
    setLoading(true);
    try {
      const productCategoryLayout = await updateProductCategoryLayout({
        productCategoryMenu: request,
      });

      setCategoryMenuLayout(productCategoryLayout.productCategoryMenu);
    } catch (error) {
      console.error(error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return {
    updateCategoryAisleLayout,
    updateCategoryMenuLayout,
    loading,
    error,
  };
}
